module.exports = __webpack_public_path__ + "static/media/center-image-pointing-right.d7d7c4c6.svg";